import React from "react";
import Raven from "raven-js";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";

import Routes from "./routes";
import registerServiceWorker from "./registerServiceWorker";
import { authCheck } from "./system/store/auth/actions";

import "./index.css";

Raven.config(
  "https://933612f735084f7fa076649e201f5f99@sentry.io/1195078"
).install();
// Check if user is logged in
store.dispatch(authCheck());

ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js